import { AREE } from '../../constants/areas';
import { listKnownAreas } from '../../lib/areaColors';

/**
 * Skeleton del CoachStatePanel: ricalca la struttura (stesse aree con il loro
 * bordo colorato) e mostra blocchi grigi animati al posto dei contenuti.
 * Niente testo "Caricamento": il movimento delle barre dà il feedback.
 */
export default function CoachStatePanelSkeleton({ title = 'Stato', testid = 'coach-state-skeleton' }) {
  const areas = listKnownAreas().filter((a) => AREE[a]);
  return (
    <aside className="border border-line bg-paper overflow-hidden" data-testid={testid}>
      <div className="px-5 py-4 border-b border-line">
        <div className="mono-label mb-1">{title}</div>
        <div className="h-3 w-24 bg-line animate-pulse rounded" />
        <div className="h-4 w-36 bg-line animate-pulse rounded mt-2.5" />
      </div>
      <div className="p-3 space-y-2">
        {areas.map((area) => (
          <div
            key={area}
            className="mb-2 border-l-2 pl-3 py-2"
            style={{ borderLeftColor: AREE[area].color }}
          >
            <div className="h-3 w-28 bg-line animate-pulse rounded mb-2" />
            <div className="space-y-1.5 pl-2">
              <div className="h-2.5 w-full bg-line animate-pulse rounded" />
              <div className="h-2.5 w-4/5 bg-line animate-pulse rounded" />
              <div className="h-2.5 w-3/5 bg-line animate-pulse rounded" />
            </div>
          </div>
        ))}
      </div>
    </aside>
  );
}
